export default "__VITE_ASSET__DOgkyA_t__"